import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { BackToStore } from "../../BackToStore/BackToStore";
import { LeadFormCart } from "../../LeadForm/LeadFormCart";

export const CartHeader: FunctionComponent<{ isOrder: boolean }> = ({
  isOrder,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <header className="grid grid-cols-2 grid-rows-2 gap-2 mt-4 md:mt-[4.4rem]">
        <div className="col-span-1 md:col-span-2 row-start-1">
          <BackToStore />
        </div>
        <h1 className="col-span-2 md:col-span-1 md:row-start-2">
          {t(`cart.header.${isOrder ? "order" : "quote"}`)}
        </h1>
        <LeadFormCart />
      </header>
    </>
  );
};
